/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/rejectionManagementWizardModal"/>
import * as React from "react";
import { RejectionManagementWizard } from "./rejectionManagementWizard";
import { mapFromNorthstarToApa } from "Core/Medius.Core.Web/Scripts/lib/northstarLocalization";
import { getCultureCode } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import { LocalizationContext } from "@medius/ui-controls";
import { EntityType } from "Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/shared/interfaces";
import { ReasonCodeOperationType } from "../shared/interfaces";

export interface RejectionManagementWizardModalProps {
    wizardType: ReasonCodeOperationType;
    documentId: number;
    hierarchyId: string;
    task: string;
    rejectedEntityType: EntityType;
    show: boolean;
    onClose: () => void;
    action: () => void; 
}

export const RejectionManagementWizardModal: React.FC<RejectionManagementWizardModalProps> = ({ show, ...otherProps }) => {

    if (!show) return null;
    return (
        <LocalizationContext.Provider value={{
                translate: (key: string, defaultValue?: string) => mapFromNorthstarToApa(key, defaultValue),
                getLocale: () => getCultureCode()
            }}>
                <RejectionManagementWizard {...otherProps} />
        </LocalizationContext.Provider>
    );
};